import { create } from 'zustand';
import type { User, Tenant } from '@trinco/shared';

interface AuthState {
  user: User | null;
  tenant: Tenant | null;
  setUser: (user: User | null) => void;
  setTenant: (tenant: Tenant | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  tenant: null,
  setUser: (user) => set({ user }),
  setTenant: (tenant) => set({ tenant }),
  logout: () => set({ user: null, tenant: null }),
}));
